/*
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-11-14 11:03:16
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-11-27 17:23:39
 * @FilePath: \合联\oms\src\api\finance\riskControl_new.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/finance/arrears/v2/'

export const apis = buildApi({
  get: [name + 'index&list', name + 'detail', name + 'statusLog/:id&statusLog'],
  post: [name + 'save', name + 'delete/:id&del', name + 'reTotal', name + 'setStatus', name + 'setRemarks']
})